import express, { Router } from 'express';

import * as bankAccountValidation from '@/modules/bankAccount/bankAccount.validation';
import * as bankAccountsController from '@/modules/bankAccount/bankAccount.controller';

import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { AuditMode } from '@/shared/constants/enum.constant';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import validate from '@/shared/utils/middlewares/validate.middleware';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.BANK_ACCOUNT, ACTIONS.READ),
    validate(bankAccountValidation.getBankAccount),
    bankAccountsController.getBankAccount,
  )
  .post(
    userAuthAndCheckPermissions(),
    validate(bankAccountValidation.createBankAccount()),
    setAuditFields({ mode: AuditMode.CREATE }),
    bankAccountsController.createBankAccount,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(),
    validate(bankAccountValidation.getBankAccount),
    bankAccountsController.getBankAccountById,
  )
  .patch(
    userAuthAndCheckPermissions(),
    validate(bankAccountValidation.updateBankAccount()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    bankAccountsController.updateBankAccount,
  )
  .delete(
    userAuthAndCheckPermissions(),
    validate(bankAccountValidation.deleteBankAccountById),
    bankAccountsController.deleteBankAccountById,
  );

export default router;
